import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import * as turf from '@turf/helpers';
import union from '@turf/union';
/**
 * 专门处理 Tile 数据相关
 */

export var TileSourceService = /*#__PURE__*/function () {
  function TileSourceService() {
    _classCallCheck(this, TileSourceService);
  }

  _createClass(TileSourceService, [{
    key: "getCombineFeature",
    value: function getCombineFeature(features) {
      var p = null;
      var properties = features[0];
      features.map(function (feature) {
        var polygon = turf.polygon(feature.coordinates);

        if (p === null) {
          p = polygon;
        } else {
          p = union(p, polygon);
        }
      });

      if (properties) {
        p.properties = _objectSpread({}, properties);
      }

      return p;
    }
  }]);

  return TileSourceService;
}();